export default "__VITE_ASSET__DVkdHlll__"